export enum HsaClassificationCategoryStatus {
  Auto = "auto",
  NeedsReview = "needs_review",
  Confirmed = "confirmed",
  Rejected = "rejected",
}
